import {DeleteFavoriteAddressServiceParams} from '../types';
import {makeDeleteBeneficiaryAddressV4} from 'main/factories/usecases';

export async function deleteFavoriteAddress({
	sequence,
	signal,
}: DeleteFavoriteAddressServiceParams) {
	await makeDeleteBeneficiaryAddressV4(sequence).delete({
		sequence,
		signal,
	});
}
